export const SubscriptionCancellationReasons: string[] = [
    'settings.billing.cancelReasons.tooExpensive',
    'settings.billing.cancelReasons.usingSomethingElse',
    'settings.billing.cancelReasons.serviceIssues',
    'settings.billing.cancelReasons.missingFeatures',
    'settings.billing.cancelReasons.productStability',
    'settings.billing.cancelReasons.notUsingEnough',
    'settings.billing.cancelReasons.other',
];
